import React, { FunctionComponent } from "react";
import { Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { CircleColorIcon } from "../../../../assets/icons/circle-color-icon";
import { HeadingText } from "../../../../components/text/heading-text";
import { ContentText } from "../../../../components/text/content-text";

const A_COLOR = "#F2C148";
const T_COLOR = "#F09941";
const C_COLOR = "#3A6D79";
const G_COLOR = "#82BECC";

const useStyles = makeStyles((theme: Theme) => ({
  explain: {
    paddingTop: theme.spacing(2),
  },
  explain_2: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
  bottomContainer: {
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(4),
  },
  bodyTextContainer: {
    height: "100%",
  },
  bodyText: {
    fontSize: 14,
    fontWeight: 300,
  },
  bodyImg: {
    maxHeight: 200,
    paddingTop: theme.spacing(5),
  },
  circlesText: {
    paddingTop: theme.spacing(4),
  },
}));

interface IGeneVariationProps {}

export const GeneVariation: FunctionComponent<IGeneVariationProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item container direction="row">
        <HeadingText>{t("gene_variations.page_1.header")}</HeadingText>
      </Grid>
      <Grid item container direction="row" className={classes.explain}>
        <ContentText light>{t("gene_variations.page_1.explanation_1")}</ContentText>
      </Grid>
      <Grid item container direction="row" className={classes.explain_2}>
        <ContentText light>{t("gene_variations.page_1.explanation_2")}</ContentText>
      </Grid>

      <Grid item container direction="row" className={classes.bottomContainer} spacing={10}>
        <Grid item xs={12} sm={4} md={12} lg={4}>
          <Grid container direction="column" justify={"space-between"} className={classes.bodyTextContainer}>
            <Typography className={classes.bodyText}>{t("gene_variations.page_1.nucleus")}</Typography>
            <img className={classes.bodyImg} src="/images/storydata/nucleus.svg" alt="nucleus" />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4} md={12} lg={4}>
          <Grid container direction="column" justify={"space-between"} className={classes.bodyTextContainer}>
            <Grid item>
              <Typography className={classes.bodyText}>{t("gene_variations.page_1.double_helix")}</Typography>
              <Grid container justify={"center"} spacing={2} className={classes.circlesText}>
                <Grid item container xs={12} spacing={2} justify={"center"}>
                  <Grid item xs={3} sm={12} md={3} lg={6}>
                    <Grid container justify={"center"}>
                      <Typography className={classes.bodyText} align="center">
                        <CircleColorIcon color={A_COLOR}>A</CircleColorIcon>&nbsp;
                        {t("gene_variations.page_1.adenin")}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={3} sm={12} md={3} lg={6}>
                    <Grid container justify={"center"}>
                      <Typography className={classes.bodyText} align="center">
                        <CircleColorIcon color={C_COLOR}>C</CircleColorIcon>&nbsp;
                        {t("gene_variations.page_1.cytocin")}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={3} sm={12} md={3} lg={6}>
                    <Grid container justify={"center"}>
                      <Typography className={classes.bodyText} align="center">
                        <CircleColorIcon color={T_COLOR}>T</CircleColorIcon>&nbsp;
                        {t("gene_variations.page_1.thymin")}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={3} sm={12} md={3} lg={6}>
                    <Grid container justify={"center"}>
                      <Typography className={classes.bodyText} align="center">
                        <CircleColorIcon color={G_COLOR}>G</CircleColorIcon>&nbsp;
                        {t("gene_variations.page_1.guanin")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <img className={classes.bodyImg} src="/images/storydata/helix.svg" alt="helix" />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={4} md={12} lg={4}>
          <Grid container direction="column" justify={"space-between"} className={classes.bodyTextContainer}>
            <Typography className={classes.bodyText}>{t("gene_variations.page_1.dna")}</Typography>
            <img className={classes.bodyImg} src="/images/storydata/gene.svg" alt="gene" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
